module.exports = __webpack_public_path__ + "media/images/costumes/top/swiper-dress-5-84e424f07832508d3c742a538d22dc32.jpg";